import React from "react";

function TitleIntake() {
  return (
    <div className="title-line-desktop">
      <div className="title-block1">Name of document</div>
      <div className="title-block2">Intake date</div>
      <div className="title-block3">Actions</div>
    </div>
  );
}

export default TitleIntake;
